var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "autocomplete" }, [
    _c("div", {
      staticClass: "input",
      domProps: {
        textContent: _vm._s(
          _vm.selectedItem ? _vm.selectedItem[_vm.filterby] : ""
        )
      },
      on: { click: _vm.toggleVisible }
    }),
    _vm._v(" "),
    _vm.selectedItem == null
      ? _c("div", {
          staticClass: "placeholder",
          domProps: { textContent: _vm._s(_vm.title) }
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.selectedItem
      ? _c(
          "button",
          {
            staticClass: "close",
            on: {
              click: function($event) {
                _vm.selectedItem = null
              }
            }
          },
          [_vm._v("x")]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.visible,
            expression: "visible"
          }
        ],
        staticClass: "popover"
      },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.query,
              expression: "query"
            }
          ],
          ref: "input",
          attrs: { type: "text", placeholder: "Start Typing..." },
          domProps: { value: _vm.query },
          on: {
            keydown: [
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "up", 38, $event.key, [
                    "Up",
                    "ArrowUp"
                  ])
                ) {
                  return null
                }
                return _vm.up($event)
              },
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "down", 40, $event.key, [
                    "Down",
                    "ArrowDown"
                  ])
                ) {
                  return null
                }
                return _vm.down($event)
              },
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.selectItem($event)
              }
            ],
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.query = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c("div", { ref: "optionsList", staticClass: "options" }, [
          _c(
            "ul",
            _vm._l(_vm.matches, function(match, index) {
              return _c("li", {
                key: index,
                class: { selected: _vm.selected == index },
                domProps: { textContent: _vm._s(match[_vm.filterby]) },
                on: {
                  click: function($event) {
                    return _vm.itemClicked(index)
                  }
                }
              })
            }),
            0
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }